<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ !folder_link.id ? "Create" : "Edit" }} Document Link</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<form #form="ngForm" (ngSubmit)="onSubmit(form)">

  <mat-dialog-content class="px-3 py-4">

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Document Link URL</mat-label>
      <input
        matInput
        placeholder="Document Link URL"
        [(ngModel)]="folder_link.url"
        name="url"
        type="url"
        #url
        required />
      <mat-error *ngIf="!url.valid">Please enter the Document Link URL. </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Document Link Description</mat-label>
      <textarea
        matInput
        placeholder="Document Link Description"
        [(ngModel)]="folder_link.description"
        name="description"
        type="text"
        rows="10"
        cols="30"
        #description
        matTooltip="Enter a Document Link Description.">
      </textarea>
      <mat-hint>Please enter a Document Link Description. (Optional)</mat-hint>
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">

    <button
      mat-raised-button
      [disabled]="!form.valid || inProgress"
      color="primary"
      type="submit"
      id="save"
      class="my-2 ml-1 mr-2">
      <mat-icon>save</mat-icon>
      Save
    </button>

    <button
      type="button"
      color="warn"
      mat-icon-button
      [disabled]="!folder_link.id"
      class="dialog-remove-button my-2 ml-auto mr-1"
      (click)="onDelete()">
      <mat-icon>delete</mat-icon>
    </button>

  </mat-dialog-actions>

</form>
